import { render, staticRenderFns } from "./public-case.vue?vue&type=template&id=2571d7de"
import script from "./public-case.vue?vue&type=script&lang=ts"
export * from "./public-case.vue?vue&type=script&lang=ts"
import style0 from "./public-case.vue?vue&type=style&index=0&id=2571d7de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports